import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import router from '@/router'
import CONST from '@/utils/const'
import { getOpenId } from '@/utils/auth'

const CancelToken = axios.CancelToken
let sources = []

// 定义取消操作
let removeSource = (config) => {
  for (let source in sources) {
    // 当多次请求相同时，取消之前的请求
    if (sources[source].umet === config.url + '&' + config.method) {
      sources[source].cancel('取消请求')
      sources.splice(source, 1)
    }
  }
}



// create an axios instance
const service = axios.create({
  baseURL: '/api', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 50 * 1000, // request timeout
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
    // 'Content-Type': 'application/x-www-form-urlencoded',   // 表单提交
  },
  responseType: 'json'
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // if (!config.url.startsWith('/report')) {
    //   config.url = '/api'+ config.url
    // }
    config.data = config.data || {}
    config.data.open_id = getOpenId()
    config.data.cx_user = CONST.CX_USER
    config.data.is_cw = true
    if (store.getters.currClient) {
      config.data['client_id'] = store.getters.currClient.client_id
    }

    removeSource(config)
    config.cancelToken = new CancelToken((c) => {
      // 将取消函数存起来
      sources.push({ umet: config.url + '&' + config.method, cancel: c })
    })
    return config
  },
  error => {
    // do something with request error
    console.error('request: ', error)
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    // 请求结束后将对应存储的取消函数删除
    removeSource(response.config)
    const res = response.data
    if (!res.success) {
      if (res.msg != '查询失败：\u003cQuerySeter\u003e no row found') {
        Vue.prototype.error(res.msg)
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    if (error.message !== '取消请求') {
      console.error('Response Error: ' + error) // for debug
      Vue.prototype.error(error.msg || 'Error')
      return Promise.reject(error)
    }
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js